// extracted by mini-css-extract-plugin
export default {"link":"NavigationView_link__zcChu","activeLink":"NavigationView_activeLink__iBbtz"};